<template>
  <div>
    <vue-skeleton-loader
      :width="150"
      :height="20"
      animation="fade"
      class="mt-2 mx-auto bg-mint-dark rounded-l"
    />
    <div v-for="n in count" :key="n" class="card card-style mt-5 overflow-visible">
      <div
        class="mt-n4 mx-auto rounded-circle shadow-xl bg-blue-dark d-flex justify-content-center align-items-center"
        style="height: 50px; width: 50px"
      >
        <i class="bi bi-megaphone-fill font-25 d-block pb-1"></i>
      </div>
      <div class="content text-center">
        <vue-skeleton-loader
          :height="30"
          animation="fade"
          class="w-25 mt-2 mb-2 mx-auto"
        />
        <vue-skeleton-loader
          :height="20"
          animation="fade"
          class="w-50 mt-2 mx-auto"
        />
        <div class="d-flex justify-content-center">
          <vue-skeleton-loader
            :width="100"
            :height="40"
            animation="fade"
            class="mt-2"
          />
          <vue-skeleton-loader
            :width="100"
            :height="40"
            animation="fade"
            class="mt-2 ms-2"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      default: 1,
      type: Number,
    }
  },
};
</script>
